import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-timer-icon",
  "use": "icon-timer-icon-usage",
  "viewBox": "0 0 13 12",
  "content": "<symbol viewBox=\"0 0 13 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-timer-icon\">\n<g id=\"icon-timer-icon_Group 1000005119\">\n<circle id=\"icon-timer-icon_Ellipse 1976\" cx=\"6.5\" cy=\"6\" r=\"5.5\" stroke=\"currentColor\" />\n<path id=\"icon-timer-icon_Line 264\" d=\"M6.04126 3.96704L6.04126 6.70708L8.5 6.70708\" stroke=\"currentColor\" stroke-linecap=\"round\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol